import { Schema as S } from "effect";

/**
 * A single medication from the patient's history
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const item: MedicationHistoryItem = {
 *   phNLabel: "Metformin 1000mg",
 *   phPZN: "01234567",
 *   phForm: "TAB",
 *   phPackSize: "100",
 * }
 * ```
 */
export const MedicationHistoryItemSchema = S.Struct({
  phNLabel: S.optional(S.String),
  phPZN: S.optional(S.String),
  phForm: S.optional(S.String),
  phPackSize: S.optional(S.String),
  phCompany: S.optional(S.String),
});

export type MedicationHistoryItem = S.Schema.Type<
  typeof MedicationHistoryItemSchema
>;

/**
 * Response schema for medication history
 *
 * @since 1.0.0
 */
export const MedicationHistoryResponseSchema = S.Struct({
  medications: S.Array(MedicationHistoryItemSchema),
});

export type MedicationHistoryResponse = S.Schema.Type<
  typeof MedicationHistoryResponseSchema
>;
